// state.js

export default {
    systemList: [],
    currentSystem: {
        name: 'No one selected',
        value: 0,
    },
    showHeaderSystemFilter: false,
};
